<template>
  <div class="row">
    <div class="col-lg-7 col-md-12">
      <div class="input-group input-date" :id="attrs.id + '-datepicker'">
        <flat-pickr
          :id="attrs.id + '-date'"
          :placeholder="attrs.placeholder"
          :disabled="attrs.disabled"
          :value="valueDate"
          :config="calendarConfig"
          @input="updateDate"
          class="form-control"
          v-if="!hackyReload">
        </flat-pickr>
        <span class="input-group-btn">
          <button type="button" class="btn btn-default btn-number"
              :disabled="attrs.disabled" data-toggle>
            <span class="glyphicon glyphicon-calendar"></span>
          </button>
        </span>
      </div>
    </div>
    <div class="col-lg-5 col-md-12">
      <div class="input-group input-time">
        <vue-clock-picker
          input-class="hidden"
          :value="valueTime"
          @timeset="setTimeValue"
          ref="clockpicker"
        >
        </vue-clock-picker>
        <input class="form-control" type="text" pattern="\d{2}:\d{2}"
          :id="attrs.id + '-time'" :placeholder="attrs.placeholder"
          :value="valueTime"
          :disabled="attrs.disabled"
          @change="inputTimeChangeHandler"
          @focus.stop
          @click.stop
          required>
        <span class="input-group-btn">
          <button type="button" class="btn btn-default btn-number"
              @click.stop="showPicker()"
              :disabled="attrs.disabled">
            <span class="glyphicon glyphicon-time"></span>
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// Datetime input component
// Render a calendar and a clock picker and manage their state.

import dates from '../../services/dates'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import 'flatpickr/dist/flatpickr.css'
import {French} from 'flatpickr/dist/l10n/fr'
import {Dutch} from 'flatpickr/dist/l10n/nl'
import {english} from 'flatpickr/dist/l10n/default'
import VueClockPicker from '@pencilpix/vue2-clock-picker'
import '@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css'

const calendarLocales = {
  fr: French,
  nl: Dutch,
  en: english
}

const dateFormats = {
  fr: 'd-m-Y',
  nl: 'd-m-Y',
  en: 'Y-m-d'
}

const momentFormats = {
  fr: 'DD-MM-YYYY',
  nl: 'DD-MM-YYYY',
  en: 'YYYY-MM-DD'
}

export default {
  props: ['value', 'attrs'],
  data: function () {
    return {
      hackyReload: false,
      calendarConfig: {
        wrap: true,
        dateFormat: dateFormats[this.$i18n.locale],
        locale: calendarLocales[this.$i18n.locale]
      }
    }
  },
  components: {
    flatPickr,
    VueClockPicker
  },
  methods: {
    inputTimeChangeHandler (event) {
      this.setTimeValue(event.target.value)
    },
    setTimeValue: function (input) {
      let rex = /(\d{2}):(\d{2})/
      if (rex.test(input)) {
        let matches = rex.exec(input)
        let clone = moment(this.value)
        clone.hours(matches[1])
        clone.minutes(matches[2])
        this.$emit('input', clone)
      }
    },
    updateDate: function (pickedDateString) {
      // splice together the new date value
      // with the existing time value
      // into a moment instance the new value to emit
      let parsed = moment(pickedDateString, momentFormats[this.$i18n.locale])
      if (!parsed.isValid()) {
        parsed = moment()
      }
      parsed.minutes(this.value.minutes())
      parsed.hours(this.value.hours())
      this.$emit('input', parsed)
    },
    showPicker: function (event) {
      this.$refs.clockpicker.open()
    },
    localeChangedHandler: function (l) {
      this.value.locale(l)
      this.calendarConfig.locale = calendarLocales[l]
      this.calendarConfig.dateFormat = dateFormats[l]
      // force a full redraw of the calendar
      // FIXME: make vue-flatpickr-component reload on locale change
      // FIXME: localize the clock picker
      this.hackyReload = true
      this.$nextTick(function () {
        this.hackyReload = false
      })
      return true
    }
  },
  mounted: function () {
    this.setupTimePicker()
    dates.bus.$on('locale-changed', this.localeChangedHandler)
  },
  beforeDestroy: function () {
    dates.bus.$off('locale-changed', this.localeChangedHandler)
  },
  computed: {
    valueTime: function () {
      return this.value.format('HH:mm')
    },
    valueDate: function () {
      return this.value.format(momentFormats[this.$i18n.locale])
    }
  }
}
</script>

<style lang="sass">
.input-time
  .clock-picker__dialog-header, .clock-picker__button--active,
  .clock-picker__button--active:active, .clock-picker__button--active:hover,
  .clock-picker__button--active:focus, .clock-picker__minutes .minutes__item--small .clock-picker__button--active
    // the vue2-clock-picker npm module has the !important property specified
    background-color: #ff2d55 !important
  .clock-picker__dialog-action
    color: #ff2d55

.body
  .flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange,
  .flatpickr-day.selected.inRange, .flatpickr-day.startRange.inRange,
  .flatpickr-day.endRange.inRange, .flatpickr-day.selected:focus,
  .flatpickr-day.startRange:focus, .flatpickr-day.endRange:focus,
  .flatpickr-day.selected:hover, .flatpickr-day.startRange:hover,
  .flatpickr-day.endRange:hover, .flatpickr-day.selected.prevMonthDay,
  .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay,
  .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.nextMonthDay,
  .flatpickr-day.endRange.nextMonthDay
    background-color: #ff2d55
    border-color: #ff2d55
</style>
